module.exports = __webpack_public_path__ + "static/media/image-service-page-1.2d15ecdc.png";